
const routes = {
    CREATOR: '/creator',
    LOGIN:'/login',
    SIGNUP:'/signup',
    DISCOVER:'/discover',
    ADDTOCART:'/cart',
    CHECKOUT:'/checkout',
    ADDRESSE:'/addresse',
    PRODUCT_DETAILS:'/detailsproduct/:id',
    DETAILS:'/details',
    PROFILE:'/profile/*',
    USER_PROFILE:'/userprofile',
    USER_PRODUCTS:'/products',
    ORDER_SUCCESS:'/order-success',
    ORDER_DETAIL:'/orders/:id',
    ORDER_RETURN:'/orders/:id/return',
    ORDER_RETURN_STATUS:'/orders/:id/return-status',
    RETURN_AND_REFUND:'/ReturnandRefund',
    STYLES:'/styles',
    SELECTIONS:'/selections',
    LIKED_IMAGES:'/liked-images',
    LIKED_PRODUCTS:'/liked-products',
    MY_ACCOUNT:'/myaccount',
    MY_PROFILE:'/myprofile',
    MY_ADDRESS:'/myaddress',
    CHANGE_PASSWORD:'/changepassword',
    FORGOT_PASSWORD:'/forgotpassword',
    NOTIFY:'/notify',
    MY_CART:'/mycart',
    DISCOVER_DETAILS:'/discoverdetails',
    BRAND_COLLECTION:'/collection/:brandId',




}
export default routes